import { AdditionalChargeKbn } from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const searchFormList: any = [
  {
    label: "区分",
    keyword: "searchKbn",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(AdditionalChargeKbn),
  },
  {
    label: "請求先名",
    keyword: "searchBillingContractorName",
    type: "label",
    inputProps: {
      maxLength: 48,
    },
  },
];

const searchFormSchema = {
  searchBillingContractorName: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
};

const headList = [
  { headTitle: "請求ID" },
  { headTitle: "請求先名" },
  { headTitle: "区分" },
  { headTitle: "割増金請求金額" },
];

export { searchFormList, searchFormSchema, headList };
